import { Button } from "@/components/ui/button";
import { PopoverContent } from "@/components/ui/popover";
import {
    Tooltip,
    TooltipContent,
    TooltipProvider,
    TooltipTrigger,
} from "@/components/ui/tooltip";
import { cn } from "@/lib/utils";

export type SuggestionListProps = {
    suggestions: string[];
    onSelect: (suggestion: string) => void;
    className?: string;
    getUnavailableReason?: (suggestion: string) => string | undefined;
};

export const SuggestionList = ({
    suggestions,
    onSelect,
    className,
    getUnavailableReason,
}: SuggestionListProps) => {
    if (!suggestions.length) return null;

    return (
        <PopoverContent
            align="start"
            className={cn(
                "flex max-h-60 w-fit min-w-50 max-w-full flex-col overflow-y-auto rounded-md border bg-white p-0 pr-2 shadow-lg",
                className,
            )}
            collisionPadding={8}
            onOpenAutoFocus={(e) => e.preventDefault()}
        >
            <TooltipProvider delayDuration={100}>
                {suggestions.map((suggestion) => {
                    const unavailableReason =
                        getUnavailableReason?.(suggestion);

                    const item = (
                        <Button
                            key={suggestion}
                            aria-disabled={Boolean(unavailableReason)}
                            className={cn(
                                "w-full justify-start rounded-none p-3 font-normal hover:bg-gray-100",
                                unavailableReason &&
                                    "cursor-not-allowed text-text-disabled hover:bg-transparent hover:text-text-disabled",
                            )}
                            onClick={(e) => {
                                e.stopPropagation();
                                if (!unavailableReason) {
                                    onSelect(suggestion);
                                }
                            }}
                            onMouseDown={(e) => e.preventDefault()}
                            variant="ghost"
                        >
                            {suggestion}
                        </Button>
                    );

                    if (!unavailableReason) {
                        return item;
                    }

                    return (
                        <Tooltip key={suggestion}>
                            <TooltipTrigger asChild>{item}</TooltipTrigger>
                            <TooltipContent side="right">
                                {unavailableReason}
                            </TooltipContent>
                        </Tooltip>
                    );
                })}
            </TooltipProvider>
        </PopoverContent>
    );
};
